import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { supabase } from "../lib/supabase";

const AUTH_USER_KEY = "ce_current_user_id";
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [seedUsers, setSeedUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchSeedUsers() {
      const { data, error } = await supabase
        .from("users")
        .select("id, display_name, avatar_url, is_seed, is_verified, rank, community_points, rating_avg, rating_count")
        .eq("is_seed", true)
        .order("display_name");
      if (!error && data) {
        setSeedUsers(data);
        const savedId = localStorage.getItem(AUTH_USER_KEY);
        const saved = savedId && data.find((u) => u.id === savedId);
        setUser(saved || data[0]);
      }
      setLoading(false);
    }
    fetchSeedUsers();
  }, []);

  const switchUser = useCallback((newUser) => {
    if (newUser.id === user?.id) return;
    localStorage.setItem(AUTH_USER_KEY, newUser.id);
    window.location.replace("/");
  }, [user?.id]);

  return (
    <AuthContext.Provider value={{ user, switchUser, seedUsers, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
